import axios from 'axios'
import { useAtomValue } from 'jotai'
import { useQuery } from '@tanstack/react-query'

import { searchSubmissionAtom } from '../../state'
import type { GarageLaterAvailabilityResponse } from '../types'
import { getLaterStartOptions } from '../later-availability'

export const useLaterAvailabilityQuery = ({
    enabled = true,
    includeAll = false,
}: {
    enabled?: boolean,
    includeAll?: boolean,
} = {}) => {
    const searchSubmission = useAtomValue(searchSubmissionAtom)
    const {
        startDate,
        startTime,
        endDate,
        endTime,
    } = searchSubmission
    const eligibleSearch =
        startDate?.isoWeekday() === 5 &&
        getLaterStartOptions(startTime).length > 0

    return useQuery<GarageLaterAvailabilityResponse>({
        queryKey: [
            'garagesLaterAvailability',
            startDate?.format('YYYY-MM-DD'),
            startTime,
            endDate?.format('YYYY-MM-DD'),
            endTime,
            includeAll,
        ],
        queryFn: async () => {
            const { data } = await axios.get<GarageLaterAvailabilityResponse>(
                '/api/garages/later_availability',
                {
                    params: {
                        begins_at_date: startDate?.format('YYYY-MM-DD') ?? '',
                        begins_at_time: startTime ?? '',
                        ends_at_date: endDate?.format('YYYY-MM-DD') ?? '',
                        ends_at_time: endTime ?? '',
                        ...(includeAll ? { include_all: true } : {}),
                    },
                },
            )
            return data
        },
        enabled: enabled && eligibleSearch,
    })
}
